module.exports = __webpack_public_path__ + "static/media/collage2_1.f0e30e55.png";